import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track"]

  connect() {
    this.paused = false
    this.element.addEventListener("mouseenter", () => this.pause())
    this.element.addEventListener("mouseleave", () => this.resume())
    this.startAnimation()
  }

  startAnimation() {
    const track = this.trackTarget
    track.style.animation = "marquee-scroll 30s linear infinite"
  }

  pause() {
    this.trackTarget.style.animationPlayState = "paused"
  }

  resume() {
    this.trackTarget.style.animationPlayState = "running"
  }
}
